var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconServiceSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_971_60576)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_971_60576",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_971_60576)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_971_60576",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_971_60576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1959 8.07255C16.0114 6.53394 15.2605 5.11919 14.0896 4.10408C12.9188 3.08897 11.4118 2.54625 9.86261 2.58172C8.36031 2.61168 6.91962 3.18438 5.80675 4.194C4.69389 5.20362 3.98406 6.58192 3.80844 8.07422H4.47511C4.52467 8.06907 4.57427 8.08368 4.61312 8.11489C4.65198 8.14609 4.67694 8.19137 4.68261 8.24088C5.14594 9.98088 5.61261 11.72 6.0826 13.4584C6.11594 13.5826 6.06594 13.6409 5.97677 13.7084C5.54913 14.0188 5.04996 14.2162 4.52563 14.2821C4.0013 14.348 3.46882 14.2804 2.97764 14.0854C2.48646 13.8904 2.05252 13.5745 1.71612 13.167C1.37971 12.7594 1.15176 12.2734 1.05344 11.7542C0.948763 11.2214 0.986652 10.6704 1.16327 10.1569C1.33989 9.64345 1.64898 9.18573 2.05927 8.83005C2.12411 8.76865 2.16514 8.68629 2.17511 8.59755C2.22742 6.81929 2.88489 5.11209 4.03888 3.7581C5.19286 2.40411 6.77427 1.48437 8.52177 1.15088C9.5356 0.957301 10.5777 0.966114 11.5881 1.17682C12.5985 1.38752 13.5573 1.79595 14.4092 2.37861C15.2612 2.96127 15.9895 3.70665 16.5523 4.57186C17.1151 5.43707 17.5012 6.40504 17.6884 7.42005C17.7543 7.80422 17.7718 8.19672 17.8218 8.58672C17.8344 8.68096 17.8771 8.76862 17.9434 8.83672C18.2892 9.14249 18.563 9.52094 18.7453 9.94496C18.9276 10.369 19.0139 10.8281 18.998 11.2893C18.9821 11.7506 18.8643 12.2027 18.6532 12.6131C18.4421 13.0235 18.1428 13.3822 17.7768 13.6634C17.6936 13.7315 17.6234 13.8139 17.5693 13.9067C16.5446 15.6938 14.8528 17.0014 12.8651 17.5426C12.7994 17.5552 12.7382 17.585 12.6878 17.6289C12.6373 17.6728 12.5993 17.7293 12.5776 17.7926C12.4166 18.2002 12.121 18.5406 11.74 18.7572C11.3589 18.9738 10.9153 19.0536 10.4826 18.9834C10.0574 18.9168 9.66598 18.7122 9.36868 18.401C9.07138 18.0898 8.88476 17.6895 8.8376 17.2617C8.79109 16.8296 8.88933 16.3943 9.11692 16.024C9.3445 15.6538 9.68855 15.3695 10.0951 15.2159C10.5025 15.0631 10.9495 15.0518 11.3642 15.1835C11.7789 15.3153 12.1372 15.5826 12.3818 15.9426L12.4809 16.0851C12.6018 16.0292 12.7068 15.9692 12.8201 15.93C13.7824 15.5922 14.6486 15.0267 15.3451 14.2817C15.2849 14.2681 15.2256 14.2506 15.1676 14.2292C14.7815 14.0537 14.3962 13.8764 14.0118 13.6976C13.9034 13.6467 13.8851 13.5651 13.9168 13.4475C14.384 11.7164 14.8482 9.98422 15.3093 8.25088C15.3121 8.22438 15.3201 8.1987 15.3328 8.1753C15.3456 8.1519 15.3628 8.13125 15.3836 8.11452C15.4043 8.0978 15.4282 8.08534 15.4537 8.07785C15.4793 8.07036 15.5061 8.068 15.5326 8.07088C15.7484 8.07422 15.9634 8.07255 16.1959 8.07255Z",
    fill: "#FFB31A"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_971_60576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServiceSidebar);
export default __webpack_public_path__ + "static/media/icon-service-sidebar.f1af35252644ca135c28e2e1b9a6175f.svg";
export { ForwardRef as ReactComponent };